// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bde2e3e7","455":"ec834fb8"}[chunkId] + ".chunk.js";
};